import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ProductList from "./ProductList";
import { fetchCategories } from "../../../redux/features/searchCategorySlice";
import { Box, Button } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { useLocation } from "react-router-dom";

const ShopNewDesign = () => {
  const dispatch = useDispatch();
  const lang = useSelector((state) => state.language.lang);
  const { childCategories } = useSelector((state) => state.categories);
  const location = useLocation();

  const [selectedChildCategory, setSelectedChildCategory] = useState(null);
  const sliderRef = useRef(null);

  // 🟢 Load child categories whenever URL changes
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const parentCategoryId = params.get("parent_category_id");
    const categoryId = params.get("category_id");

    setSelectedChildCategory(categoryId || null);

    dispatch({ type: "categories/clearChildCategories" });

    if (parentCategoryId) {
      dispatch(fetchCategories({ lang, parent_id: parentCategoryId }));
    } else {
      dispatch(fetchCategories({ lang }));
    }
  }, [location.search, dispatch, lang]);

  return (
    <>
      {/* Product List always shows */}
      <ProductList />
    </>
  );
};

export default ShopNewDesign;
